export var LoadingState;

(function (LoadingState) {
  LoadingState[LoadingState["Pending"] = 0] = "Pending";
  LoadingState[LoadingState["Success"] = 1] = "Success";
  LoadingState[LoadingState["Error"] = 2] = "Error";
})(LoadingState || (LoadingState = {}));